export const mobile = {
  'backoffice.mobile.tabs.home': 'Start',
  'backoffice.mobile.tabs.accounts': 'Konten',
  'backoffice.mobile.tabs.profits': 'Gewinne',
  'backoffice.mobile.tabs.commissions': 'Provisionen',
  'backoffice.mobile.tabs.more': 'Mehr',
  'backoffice.mobile.more.myProfitHistory': 'Mein Gewinnverlauf',
};
